export default {
    type: 'widget',
    config: {
        minWidth: {
            desktop: 200,
            mobile: 120
        },
        align: 'left'
    },
    default: {
        label: 'Game'
    },
    sort: 'name',
    unique: [
        {
            key: 'status',
            type: 'checklist',
            default: 'enabled',
            name: 'Status',
            options: [
                {
                    value: 'enabled',
                    text: 'Enabled',
                    preview: 'Show status',
                    description: 'Show status labels (e.g. 4th play)'
                },
                {
                    value: 'disabled',
                    text: 'Disabled',
                    preview: 'Hide status',
                    description: 'Don\'t show status labels.'
                }
            ]
        },
        {
            key: 'date',
            type: 'checklist',
            default: 'enabled',
            name: 'Date',
            views: ['grid'],
            options: [
                {
                    value: 'enabled',
                    text: 'Enabled',
                    preview: 'Show date',
                    description: 'Show date of play'
                },
                {
                    value: 'disabled',
                    text: 'Disabled',
                    preview: 'Hide date',
                    description: 'Don\'t show date of play'
                }
            ]
        },
        {
            key: 'location',
            type: 'checklist',
            default: 'enabled',
            name: 'Location',
            options: [
                {
                    value: 'enabled',
                    text: 'Enabled',
                    preview: 'Show location',
                    description: 'Show play location if provided'
                },
                {
                    value: 'disabled',
                    text: 'Disabled',
                    preview: 'Hide location',
                    description: 'Don\'t show play location'
                }
            ]
        },
        {
            key: 'duration',
            type: 'checklist',
            default: 'enabled',
            name: 'Duration',
            views: ['grid'],
            options: [
                {
                    value: 'enabled',
                    text: 'Enabled',
                    preview: 'Show duration',
                    description: 'Show play duration if provided'
                },
                {
                    value: 'disabled',
                    text: 'Disabled',
                    preview: 'Hide duration',
                    description: 'Don\'t show play duration'
                }
            ]
        },
        {
            key: 'count',
            type: 'checklist',
            default: 'enabled',
            name: 'Player Count',
            views: ['grid'],
            options: [
                {
                    value: 'enabled',
                    text: 'Enabled',
                    preview: 'Show count',
                    description: 'Show play count'
                },
                {
                    value: 'disabled',
                    text: 'Disabled',
                    preview: 'Hide count',
                    description: 'Don\'t show player count'
                }
            ]
        },
        {
            key: 'players',
            type: 'checklist',
            default: 'enabled',
            name: 'Players',
            views: ['grid'],
            options: [
                {
                    value: 'enabled',
                    text: 'Enabled',
                    preview: 'Show players',
                    description: 'Show player names'
                },
                {
                    value: 'disabled',
                    text: 'Disabled',
                    preview: 'Hide players',
                    description: 'Don\'t show player names'
                }
            ]
        },
        {
            key: 'tags',
            type: 'checklist',
            default: 'enabled',
            name: 'Tags',
            options: [
                {
                    value: 'enabled',
                    text: 'Enabled',
                    preview: 'Show tags',
                    description: 'Show any applicable tags'
                },
                {
                    value: 'disabled',
                    text: 'Disabled',
                    preview: 'Hide tags',
                    description: 'Don\'t show any applicable tags'
                }
            ]
        },
        {
            key: 'report',
            type: 'checklist',
            default: 'enabled',
            name: 'Report',
            contexts: ['plays'],
            views: ['list'],
            options: [
                {
                    value: 'enabled',
                    text: 'Enabled',
                    preview: 'Show report',
                    description: 'Show report if exists'
                },
                {
                    value: 'disabled',
                    text: 'Disabled',
                    preview: 'Hide report',
                    description: 'Don\'t show report'
                }
            ]
        }
    ],
    lang: {
        name: 'Play Info',
        views: ['list'],
        contexts: ['plays'],
        category: 'Game',
        description: 'Summary of play with optional stuff.'
    }
}